"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
function loadBusinesses() {
    return { type: constants_1.ACTIONS.Businesses.LOAD_BUSINESSES };
}
exports.loadBusinesses = loadBusinesses;
function updateBusinesses(businessId, group) {
    return { type: constants_1.ACTIONS.Businesses.UPDATE_BUSINESSES, payload: { businessId, group } };
}
exports.updateBusinesses = updateBusinesses;
function loadBusinessesSuccess(businesses = []) {
    return { type: constants_1.ACTIONS.Businesses.LOAD_BUSINESSES_SUCCESS, payload: { businesses } };
}
exports.loadBusinessesSuccess = loadBusinessesSuccess;
function loadBusinessesFailed(payload) {
    return { type: constants_1.ACTIONS.Businesses.LOAD_BUSINESSES_FAILED, payload };
}
exports.loadBusinessesFailed = loadBusinessesFailed;
function setBusiness(payload) {
    return {
        type: constants_1.ACTIONS.Businesses.SET_BUSINESS, payload
    };
}
exports.setBusiness = setBusiness;


//////////////////
// WEBPACK FOOTER
// ./client/src/app/business/BusinessesActions.ts
// module id = 782
// module chunks = 0 1 2